import React from 'react';
import LiteralsService from 'src/services/literals/LiteralsService';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import adobeTags from 'src/types/adobe-tags';
import Selectors from 'src/utils/selectors';
import { getCategoryTransactionsUrl, goToBudgetCategoryTransactions } from 'src/services/router.service';
import { IconActivity } from '@americanexpress/dls-react';
import SelectDetailed from 'src/components/formik-fields/selectDetailed/SelectDetailed';
import H from 'history';
import { useHistory } from 'react-router-dom';
import { LocalDate } from '@js-joda/core';
import styles from './spendingLineGraphHeading.module.scss';
import ChartTimePeriod from 'src/components/atomic/molecules/chartTimePeriod/ChartTimePeriod';
import DateUtils from 'src/utils/date';
import { SpendingLineGraphChartOption } from 'src/types/spendingLineGraph';

interface Props {
    chartOptions?: SpendingLineGraphChartOption[];
    propHistory?: H.History;
}

export default function SpendingLineGraphHeading({ chartOptions, propHistory }: Props): JSX.Element {
    const history = useHistory();
    const currentMonthStartDate: LocalDate = DateUtils.startDateOfThisMonth();
    const currentMonthEndDate: LocalDate = currentMonthStartDate.plusMonths(1).minusDays(1);

    return (
        <div className={styles.currentMonthChartHeading}>
            <ChartTimePeriod
                startDate={currentMonthStartDate}
                endDate={currentMonthEndDate}
                propHistory={propHistory}
            />
            <Anchor
                onClick={() => goToBudgetCategoryTransactions(false, history)}
                tag={adobeTags.General.ViewTransactions}
                href={getCategoryTransactionsUrl()}
                className={styles.viewTransactionsLink}
                data-cy={Selectors.SpendSmart.VIEW_CURRENT_MONTH_TRANSACTIONS_LINK}
                aria-label={LiteralsService.getLiteral('Budget.Current.viewAllTransactionsLinkDescription')}
                inline
            >
                <IconActivity className={styles.linkIcon} />
                {LiteralsService.getLiteral('Budget.Current.viewTransactions')}
            </Anchor>
            <SelectDetailed
                id="comparisonMonth"
                weak
                className={styles.chartTimeFrameDropdown}
                label={LiteralsService.getLiteral('Budget.Current.graph.dropdownLabel')}
                labelKey="label"
                options={chartOptions}
            />
        </div>
    );
}
